var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-link"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    clipPath: "url(#clip-link)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-link",
    "data-name": "Icon awesome-link",
    d: "M15.005,8.517a6.98,6.98,0,0,1,.017,9.859l-.017.017L11.918,21.48A6.983,6.983,0,1,1,2.042,11.6l1.7-1.7A.734.734,0,0,1,5,10.387a8.466,8.466,0,0,0,.445,2.422.739.739,0,0,1-.174.763l-.6.6a3.308,3.308,0,1,0,4.648,4.708l3.087-3.087a3.307,3.307,0,0,0,0-4.678,3.442,3.442,0,0,0-.475-.394.737.737,0,0,1-.319-.579,1.83,1.83,0,0,1,.537-1.369l.967-.967a.738.738,0,0,1,.946-.08,7.005,7.005,0,0,1,.943.79ZM21.48,2.042a6.991,6.991,0,0,0-9.876,0L8.517,5.129,8.5,5.146A6.985,6.985,0,0,0,9.46,15.8a.738.738,0,0,0,.946-.08l.967-.967a1.83,1.83,0,0,0,.537-1.369.737.737,0,0,0-.319-.579,3.442,3.442,0,0,1-.475-.394,3.307,3.307,0,0,1,0-4.678L14.2,4.641a3.308,3.308,0,1,1,4.648,4.708l-.6.6a.739.739,0,0,0-.174.763,8.466,8.466,0,0,1,.445,2.422.734.734,0,0,0,1.254.487l1.7-1.7a6.991,6.991,0,0,0,0-9.876Z",
    transform: "matrix(0.719, -0.695, 0.695, 0.719, -1.63, 14.71)",
    fill: "#8bc500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.5b81b73f004b987f75ffef537c3648e2.svg";
export { ForwardRef as ReactComponent };